import { useMutation } from '@tanstack/react-query';
import * as service from '../services';
import { useOmnichannelStore } from '../store/ModuloOmnichannel.store';
import { DetailsProductsRequest } from '../types';
import { AxiosResponse } from 'axios';
import { useDebounce } from '../../../../../hooks';
import { useNotification } from '../../../../../hooks';

export const useGetOmnichannelDetailingProducts = () => {
  const setOmnichannelState = useOmnichannelStore(state => state.setOmnichannelState);
  const debounce = useDebounce();
  const { handleNotification } = useNotification();

  const setBodyRequest = (rede: string, name: string, data: any): DetailsProductsRequest => {
    const omnichannelDetailsProductsBodyRequest = useOmnichannelStore.getState().omnichannelDetailsProductsBodyRequest;
    const omnichannelRequestBody = useOmnichannelStore.getState().omnichannelRequestBody;

    return {
      params: {
        ...omnichannelDetailsProductsBodyRequest.params,
        sort: name === 'sort' ? data?.sort : omnichannelDetailsProductsBodyRequest.params.sort,
        direction: name === 'sort' ? data?.direction : omnichannelDetailsProductsBodyRequest.params.direction,
      },
      body: {
        ...omnichannelRequestBody,
        redes: [rede],
        page: name === 'page' ? data : omnichannelDetailsProductsBodyRequest.body.page,
        size: name === 'size' ? data : omnichannelDetailsProductsBodyRequest.body.size,
        query: name === 'query' ? data : omnichannelDetailsProductsBodyRequest.body.query,
      },
    };
  };

  const requestDetailingProduct = (bodyRequest: DetailsProductsRequest) => {
    setOmnichannelState('omnichannelDetailsProductsBodyRequest', bodyRequest);
    mutation.mutate(bodyRequest);
  };

  const successAction = (data: AxiosResponse) => {
    setOmnichannelState('omnichannelDetailsProductsTableData', data.data);
  };

  const errorAction = () => {
    handleNotification('error', 'Erro ao buscar lista de detalhamento de produtos');
  };

  const mutation = useMutation({
    mutationFn: (data: DetailsProductsRequest) => service.getOmnichannelDetailsProducts(data),
    onSuccess: data => successAction(data),
    onError: errorAction,
  });

  const handleOmnichannelDetailingProductsPageChange = (rede: string, page: number) => {
    const bodyRequest = setBodyRequest(rede, 'page', page);
    requestDetailingProduct(bodyRequest);
  };

  const handleOmnichannelDetailingProductsSortChange = (rede: string, column: string, direction: 'ASC' | 'DESC') => {
    const sortData = {
      sort: column,
      direction,
    };
    const bodyRequest = setBodyRequest(rede, 'sort', sortData);
    requestDetailingProduct(bodyRequest);
  };

  const handleOmnichannelDetailingProductsQueryChange = (rede: string, query: string) => {
    debounce(() => {
      const bodyRequest = setBodyRequest(rede, 'query', [query]);
      requestDetailingProduct(bodyRequest);
    });
  };

  return {
    detailingProductsLoading: mutation.isPending,
    handleGetOmnichannelDetailingProducts: requestDetailingProduct,
    handleOmnichannelDetailingProductsPageChange,
    handleOmnichannelDetailingProductsSortChange,
    handleOmnichannelDetailingProductsQueryChange,
  };
};
